import { _createManager } from "@/factories/manager/create";

export const managerFactory = {
  create: _createManager,
} as const;
